import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { MESH_DEVICE_DETAILS } from './url-constants';

type MeshDeviceDetailsEndpointSpecification = ApiEndpointSpecification;
export const MeshDeviceDetailsEndpointSpecification: MeshDeviceDetailsEndpointSpecification = {
    url: MESH_DEVICE_DETAILS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'MeshDeviceDetailsRequestParams',
    requestBodySchemaName: 'MeshDeviceDetailsRequestBody',
    okResponseSchemaName: 'MeshDeviceDetailsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version: 3.0
};

export const invokeMeshGatewayDeviceDetails = Helpers.makeApiRequestFn<
    Types.MeshDeviceDetailsRequestParams,
    Types.MeshDeviceDetailsRequestBody,
    Types.MeshDeviceDetailsOkResponse
>(MeshDeviceDetailsEndpointSpecification);
